// Third Party
import React, { Component } from 'react';

// Components
import DataTable from '../../components/data/DataTable';

// Utils
import { formatMessage } from '../../../utils/i18n';
import { ContactAvatar } from '../../components/misc';
import AdvisorInfos from '@/types/advisor-infos';

type Props = {
  items: AdvisorInfos[];
};

class Advisors extends Component<Props> {
  getAdvisorColumns = () => [
    {
      accessor: 'imgUrl',
      className: 'advisor-avatar',
      Header: <i className="icon-user" data-private data-dd-privacy="mask" />,
      Cell: ({ original }: { original: AdvisorInfos }) => <ContactAvatar contact={original} data-private data-dd-privacy="mask" />,
      width: 50,
    },
    {
      Header: formatMessage('Insights.Advisors.Table.Name'),
      accessor: 'name',
      className: 'advisor-name',
      Cell: ({ value }: { value: string }) =>
        value ? (
          <span data-private data-dd-privacy="mask">
            {value}
          </span>
        ) : null,
    },
    {
      Header: formatMessage('Insights.Advisors.Table.Company'),
      accessor: 'company',
      className: 'advisor-company',
      Cell: ({ value }: { value: string }) =>
        value ? (
          <span data-private data-dd-privacy="mask">
            {value}
          </span>
        ) : null,
    },
  ];

  render() {
    const { items } = this.props;

    return (
      <DataTable
        className="advisors"
        columns={this.getAdvisorColumns()}
        data={items}
        selectOnRowClick={false}
        noDataText={formatMessage('Insights.Advisors.Table.NoData')}
      />
    );
  }
}

export default Advisors;
